module.exports = __webpack_public_path__ + "img/feature-one.28a7054e.svg";